import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/promotions` and `/promotions/$slug`. */
export const Route = createFileRoute('/promotions')({
  component: PromotionsLayout,
});

function PromotionsLayout() {
  return <Outlet />;
}
